import { getDateKey, getYesterdayKey } from "./dateKeys";
import { updateStreakTransaction } from "../data/streakRepo";

export async function updateUserStreakOnVisit(uid, timeZone) {
  if (!uid) return;

  try {
    const todayKey = getDateKey(timeZone);
    const yesterdayKey = getYesterdayKey(timeZone);

    await updateStreakTransaction({ uid, todayKey, yesterdayKey });

    console.info(`🔥 Streak updated successfully for UID: ${uid}`);
  } catch (err) {
    console.error("❌ Failed to update streak:", err);
  }
}

